import React, { useState, useEffect } from 'react';
import { Steps, Form, Input, ConfigProvider, Button, Upload, Space, Progress, Select, notification } from 'antd';
import { LeftOutlined, PlusOutlined } from '@ant-design/icons';
import { Checkbox } from 'antd';
import './Anchor.css';
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import Modal from 'antd/es/modal/Modal';
import Topnav from '../TopNav/Topnav';
import Header from '../Header';

const { Step } = Steps;
const API_URL = process.env.REACT_APP_API_URL;
const Token = localStorage.getItem("JwtToken");
const USERID = localStorage.getItem('UserId');

const AgentAnchorForm = () => {
  const [token, setToken] = useState(localStorage.getItem("JwtToken"));
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [refCode, setRefCode] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [videoUpload, setVideoUpload] = useState(null);
  const [imageUpload, setImageUpload] = useState(null);
  const [imageUpload1, setImageUpload1] = useState(null);
  const [imagesUpload, setImagesUpload] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [fullName, setFullName] = useState("");
  const [mobile, setMobile] = useState("");
  const [emailId, setEmailId] = useState("");
  const [age, setAge] = useState("");
  const [yearofexperience, setYearofexperience] = useState("");
  const [description, setDescription] = useState("");
  const [language, setLanguage] = useState("");
  const [category, setCategory] = useState("");
  const [specialization, setSpecialization] = useState([]);
  const [instaLink, setInstaLink] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileSizeError, setFileSizeError] = useState(false);
  const [fileSizeError1, setFileSizeError1] = useState(false);
  const [fileSizeError2, setFileSizeError2] = useState(false);
  const [agentName, setAgentName] = useState("");
  const [agentNum, setAgentNum] = useState("");
  const [price, setPrice] = useState(null);
  const [agentDetails, setAgentDetails] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [finalPrice, setFinalPrice] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [message, setMessage] = useState('');

  const option1 = {
    headers: {
      'Authorization': `Bearer ${token}`
    },
  };

  const [uploadStatus, setUploadStatus] = useState({
    poster: false,
    thumbnail: false,
    images: false
  });

  const getAmount = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/price?populate=*`)
      setPrice(res?.data?.data?.attributes?.AgentModelPrice);
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getAmount();
  }, [])

  useEffect(() => {
    setFinalPrice(price);
  }, [price]);

  const applyCoupon = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/apply-coupon`, {
        code: coupon,
        originalPrice: price,
      });

      if (response.data.valid) {
        setDiscount(response.data.discount);
        setFinalPrice(response.data.finalPrice);
        setMessage(`Coupon applied! ₹${response.data.discount} off`);
      }
    } catch (error) {
      const errorMsg = error.response?.data?.error?.message || 'Invalid or expired coupon';
      setMessage(errorMsg);
      setDiscount(0);
      setFinalPrice(price);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "fullName":
        setFullName(value);
        break;
      case "mobile":
        setMobile(value);
        break;
      case "emailId":
        setEmailId(value);
        break;
      case "description":
        setDescription(value);
        break;
      case "language":
        setLanguage(value);
        break;
      case "category":
        setCategory(value);
        break;
      case "age":
        setAge(value);
        break;
      case "yearofexperience":
        setYearofexperience(value);
        break;
      case "instaLink":
        setInstaLink(value);
        break;
      case "refcode":
        setRefCode(value);
        break;
      case "agentName":
        setAgentName(value);
        break;
      case "agentNum":
        setAgentNum(value);
        break;
      default:
        break;
    }
  };

  const handleSpecializationChange = (value) => {
    setSpecialization(value);
  };

  const getAgent = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/users/${localStorage.getItem('UserId')}?populate=*`)
      setAgentDetails(res?.data?.agent_detail !== null);
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getAgent();
  }, [])

  const UpdateAgent = async () => {
    try {
      const res = await axios.post(`${API_URL}/api/agent-details`, {
        data: {
          AgentName: agentName,
          AgentMobile: agentNum,
          users_permissions_user: localStorage.getItem('UserId')
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agentDetails) {
      await UpdateAgent();
    }

    try {
      const values = await form.validateFields();
      setLoading(true);
      
      const response = await axios.post(`${API_URL}/api/agent-anchors`, {
        data: {
          Name: values.fullName,
          MobileNumber: values.mobile,
          Email: values.emailId,
          Language: values.language,
          Category: values.category,
          Description: values.description,
          Age: values.age,
          Yearofexperience: values.yearofexperience,
          Specialization: Array.isArray(values.specialization) ? values.specialization.join(',') : values.specialization,
          Social: values.instaLink,
          referral_code: values.refcode || '',
          users_permissions_user: localStorage.getItem('UserId'),
          agentAnchor_ID: null,
          publishedAt: null
        }
      });
      
      try {
        const res = await axios.put(`${API_URL}/api/users/${USERID}`, {
          "role": 4
        }, option1)
      } catch (err) {
        console.log(err)
      }
      
      const AgentAnchorId = response.data.data.id;
      localStorage.setItem("AgentAnchorId", AgentAnchorId);
      
      setCurrentStep(currentStep + 1);
      setLoading(false);
      
    } catch (err) {
      setLoading(false);
      if (err.response) {
        notification.error({
          message: 'Upload Error',
          description: 'Server responded with an error',
          placement: 'top'
        });
      } else if (err.request) {
        notification.error({
          message: 'Network Error',
          description: 'No response received from server. Please check your network connection.',
          placement: 'top'
        });
      } else {
        notification.error({
          message: 'Upload Error',
          description: 'Fill all the required fields',
          placement: 'top'
        });
      }
    }
  }

  const validateWordCount = (_, value) => {
    if (value) {
      const words = value.trim().split(/\s+/);
      if (words.length > 200) {
        return Promise.reject(new Error('Description cannot exceed 200 words!'));
      }
    }
    return Promise.resolve();
  };

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleCancel = () => setPreviewOpen(false);
  
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    setPreviewImage(file.url || file.preview);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
    setPreviewOpen(true);
    setPreviewVisible(true);
  };

  const handleImageUpload = (file) => {
    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    try {
      if (!file || !file.file || !file.file.originFileObj) {
        return;
      }
      if (file.file.originFileObj.size > MAX_FILE_SIZE) {
        return false;
      }
      setImageUpload(file.file.originFileObj);
      setUploadProgress(prevState => ({ ...prevState, poster: file.percent }));
      setUploadStatus(prevStatus => ({ ...prevStatus, poster: true }));
      return true;
    } catch (error) {
      console.error('Error handling image upload:', error);
    }
  };

  const handleImageUpload1 = (file) => {
    const MAX_FILE_SIZE = 5 * 1024 * 1024;
    try {
      if (!file || !file.file || !file.file.originFileObj) {
        return;
      }
      if (file.file.originFileObj.size > MAX_FILE_SIZE) {
        return false;
      }
      setImageUpload1(file.file.originFileObj);
      setUploadProgress(prevState => ({ ...prevState, thumbnail: file.percent }));
      setUploadStatus(prevStatus => ({ ...prevStatus, thumbnail: true }));
      return true;
    } catch (error) {
      console.error('Error handling image upload:', error);
    }
  };

  const handleImageUpload2 = ({ fileList }) => {
    try {
      const MAX_FILE_SIZE = 5 * 1024 * 1024;
      let valid = true;
      fileList.forEach((file) => {
        if (file.originFileObj && file.originFileObj.size > MAX_FILE_SIZE) {
          valid = false;
        }
      });
      if (!valid) {
        return false;
      }
      const arrayImages = fileList.map((file) => file.originFileObj);
      setUploadProgress((prevState) => ({ ...prevState, images: fileList.length }));
      setUploadStatus((prevStatus) => ({ ...prevStatus, images: fileList.length <= 5 }));
      setImagesUpload(arrayImages);
      return true;
    } catch (error) {
      console.error('Error handling image upload:', error);
    }
  };

  useEffect(() => {
    if (uploadStatus.poster && uploadStatus.thumbnail && uploadStatus.images) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [uploadStatus]);

  const calculateOverallProgress = () => {
    let progress = 0;
    if (uploadStatus.poster) progress += 33;
    if (uploadStatus.thumbnail) progress += 33;
    if (uploadStatus.images) progress += 34;
    return progress;
  };

  const handleVideoUpload = (file) => {
    const MAX_FILE_SIZE = 200 * 1024 * 1024;

    try {
      const videoFile = file?.file?.originFileObj;

      if (!videoFile) {
        console.error('No file found.');
        return;
      }

      if (videoFile.size > MAX_FILE_SIZE) {
        notification.error({
          message: 'File Too Large',
          description: 'Reel size exceeds the maximum limit of 200MB.',
          placement: 'top'
        });
        return;
      }

      const isMp4 = videoFile.type === 'video/mp4';
      if (!isMp4) {
        notification.error({
          message: 'Invalid Format',
          description: 'Only MP4 format is allowed for reels.',
          placement: 'top'
        });
        return;
      }

      setVideoUpload(videoFile);
      setUploadProgress(prev => ({ ...prev, movie: file.percent || 100 }));
      setUploadStatus(prev => ({ ...prev, movie: true }));

    } catch (error) {
      console.error('Error handling video upload:', error);
      notification.error({
        message: 'Upload Error',
        description: 'Something went wrong while uploading the reel.',
        placement: 'top'
      });
    }
  };

  const handleUpload = async () => {
    setUploading(true);
    setLoading(true);

    const imageFormDatas = [imageUpload, imageUpload1, ...imagesUpload];
    const agentAnchorId = localStorage.getItem("AgentAnchorId");
    
    for (let i = 0; i < imageFormDatas.length; i++) {
      if (!imageFormDatas[i]) continue;
      
      const imageFormData = new FormData();
      imageFormData.append('files', imageFormDatas[i]);
      imageFormData.append('refId', agentAnchorId);
      imageFormData.append('ref', 'api::agent-anchor.agent-anchor');

      if (i === 0) {
        imageFormData.append('field', "Poster");
        const newFileData = {
          alternativeText: agentAnchorId,
          caption: 'Poster',
        };
        imageFormData.append('fileInfo', JSON.stringify(newFileData));
      }
      else if (i === 1) {
        imageFormData.append('field', "Thumbnail");
        const newFileData = {
          alternativeText: agentAnchorId,
          caption: 'Thumbnail',
        };
        imageFormData.append('fileInfo', JSON.stringify(newFileData));
      }
      else {
        imageFormData.append('field', "Images");
        const newFileData = {
          alternativeText: agentAnchorId,
          caption: 'Images',
        };
        imageFormData.append('fileInfo', JSON.stringify(newFileData));
      }

      try {
        await axios.post(`${API_URL}/api/upload`, imageFormData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        setCurrentStep(currentStep + 1);
        setLoading(false);
      } catch (error) {
        console.error(`Error uploading image ${i + 1}:`, error);
      } finally {
        setUploading(false);
        setLoading(false);
      }
    }

    if (videoUpload) {
      const videoFormData = new FormData();
      const newFileData = {
        alternativeText: agentAnchorId,
        caption: 'video',
      };
      videoFormData.append('fileInfo', JSON.stringify(newFileData));
      videoFormData.append('files', videoUpload);
      videoFormData.append('refId', agentAnchorId);
      videoFormData.append('ref', 'api::agent-anchor.agent-anchor');
      videoFormData.append('field', "VideoFile");

      try {
        await axios.post(`${API_URL}/api/upload`, videoFormData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${Token}`,
          },
        });
      } catch (error) {
        console.error('Error uploading video:', error);
      }
    }
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handleFinish = () => {
    notification.success({
      message: 'Success',
      description: 'Form submitted successfully!',
      placement: 'top'
    });
  };

  const toggleAgreement = () => {
    setAgreed(!agreed);
  };

const handlePayment = async (e) => {
  e.preventDefault();
  
  if (finalPrice <= 0) {
    notification.error({
      message: 'Error',
      description: 'Invalid payment amount',
      placement: 'top'
    });
    return;
  }
  
  const agentAnchorId = localStorage.getItem("AgentAnchorId");
  if (!agentAnchorId) {
    notification.error({
      message: 'Error',
      description: 'No agent anchor profile found. Please complete all previous steps.',
      placement: 'top'
    });
    return;
  }

  setLoading(true);

  try {
    const keyResponse = await axios.get(`${API_URL}/api/razorpay`, option1);
    const keyId = keyResponse.data.data.attributes.keyId;
    const key_secret = keyResponse.data.data.attributes.keySecret;
    
    const orderResponse = await axios.post(`${API_URL}/api/contests/${finalPrice}/create-order`, {}, option1);
    const order = orderResponse.data;

    const options = {
      key: keyId,
      key_secret: key_secret,
      amount: order.amount || order.price,
      currency: "INR",
      order_id: order.id,
      name: "MovieMads",
      config: {
        display: {
          blocks: {
            banks: {
              name: 'All payment methods',
              instruments: [
                { method: 'upi' },
                { method: 'card' },
                { method: 'wallet' },
                { method: 'netbanking' },
              ],
            },
          },
          sequence: ['block.banks'],
          preferences: {
            show_default_blocks: false
          },
        },
      },
      handler: async function (paymentResponse) {
        notification.info({
          message: 'Processing Payment',
          description: 'Please do not refresh the page',
          placement: 'top'
        });
        
        try {
          // Use the same endpoint structure as working AnchorForm
          const verificationResponse = await axios.post(
            `${API_URL}/api/agent-anchors/${agentAnchorId}/${paymentResponse.razorpay_payment_id}/payment`, 
            {}, 
            option1
          );
          
          console.log('Payment verification response:', verificationResponse.data);
          
          notification.success({
            message: 'Payment Successful',
            description: 'Your payment has been processed successfully!',
            placement: 'top'
          });
          
          handleFinish();
          
          // Clear stored ID
          localStorage.removeItem("AgentAnchorId");
          
          setTimeout(() => {
            window.location.href = "/";
          }, 2000);
          
        } catch (error) {
          console.error('Error in payment verification:', error);
          notification.error({
            message: 'Payment Verification Failed',
            description: error.response?.data?.error?.message || 'Payment verification failed. Please contact support if amount was deducted.',
            placement: 'top'
          });
        }
      },
      modal: {
        ondismiss: function() {
          setLoading(false);
          notification.info({
            message: 'Payment Cancelled',
            description: 'Payment window was closed',
            placement: 'top'
          });
        }
      }
    };

    const pay = new window.Razorpay(options);
    pay.open();
    
  } catch (error) {
    console.error('Error in handlePayment:', error);
    setLoading(false);
    notification.error({
      message: 'Payment Initialization Failed',
      description: error.response?.data?.error?.message || 'Payment initialization failed. Please try again.',
      placement: 'top'
    });
  }
};

  return (
    <>
      <Topnav />
      <Header />
      <div className="container">
        <div>
          <h1 className='contest-heading'>Agent Anchor form <p style={{ fontSize: '1.5rem', padding: '0', margin: '0' }}>(Entry fee of <p className='strikeOut'>Rs.999</p> Now Rs.{discount > 0 ? (<>{finalPrice}</>) : (<>{price}</>)} only)</p> </h1>
        </div>

        {loading ? (
          <div className="hourglassBackground">
            <div className="hourglassContainer">
              <div className="hourglassCurves"></div>
              <div className="hourglassCapTop"></div>
              <div className="hourglassGlassTop"></div>
              <div className="hourglassSand"></div>
              <div className="hourglassSandStream"></div>
              <div className="hourglassCapBottom"></div>
              <div className="hourglassGlass"></div>
            </div>
          </div>
        ) : (
          <div className="steps-container">
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: '#fba010',
                  colorText: '#ffffff',
                  colorIcon: '#ffffff',
                },
                components: {
                  Steps: {
                    colorPrimary: '#e50914',
                    algorithm: true,
                    colorText: '#ffffff',
                    colorTextTertiary: '#ffffff',
                    colorTextSecondary: '#ffffff',
                    navArrowColor: '#ffffff',
                  },
                  Button: {
                    colorPrimary: '#e50914',
                    algorithm: true,
                    colorBgContainerDisabled: '#495057',
                  },
                  Select: {
                    optionSelectedBg: '#e50914',
                    selectorBg: '#495057',
                    colorText: '#ffffff',
                    colorPrimary: '#fba010',
                    optionColor: '#212529',
                    colorBgElevated: '#212529',
                    colorBorder: '#495057',
                    borderRadiusLG: 0,
                  },
                  Form: {
                    colorPrimary: '#ffffff',
                    colorText: '#ffffff',
                    colorTextTertiary: '#ffffff',
                    colorTextSecondary: '#ffffff',
                    colorFillSecondary: '#ffffff',
                    algorithm: true,
                    labelColor: '#ffffff',
                  },
                  Typography: {
                    colorPrimary: '#ffffff',
                  },
                  Upload: {
                    colorText: '#ffffff',
                    colorIcon: '#ffffff',
                    colorPrimary: '#e50914',
                    colorFillAlter: 'rgba(251, 161, 16, 0.6)',
                    actionsColor: '#ffffff',
                  },
                  DatePicker: {
                    activeBg: '#212529',
                    colorBgContainer: '#495057',
                    colorText: '#ffffff',
                    colorBgElevated: '#212529',
                    colorPrimary: '#e50914',
                    colorBorder: '#495057',
                    borderRadius: 0,
                  },
                  Progress: {
                    defaultColor: '#fba010',
                    colorSuccess: '#e50914',
                    colorFillSecondary: '#303030',
                    fontSize: '36px',
                  },
                  TimePicker: {
                    colorBgContainer: '#495057',
                    colorText: '#ffffff',
                    colorBgElevated: '#212529',
                    colorPrimary: '#e50914',
                    colorBorder: '#495057',
                  },
                  Notification: {
                    colorBgElevated: '#212529',
                  },
                  Input: {
                    colorBgContainer: '#495057',
                    colorPrimary: '#fba010',
                    algorithm: true,
                    colorText: '#ffffff',
                    colorBorder: '#495057',
                    borderRadius: 0,
                  }
                },
              }}
            >
              <Steps current={currentStep}>
                <Step title="Details" />
                <Step title="Upload" />
                <Step title="Payment" />
              </Steps>
              <div style={{ marginTop: 30, color: "white" }}>
                {currentStep === 0 && (
                  <>
                    {!agentDetails &&
                      <div>
                        <h2>Agent Details :</h2>
                        <Form
                          layout="vertical"
                          size="large"
                          className="form-container"
                        >
                          <div className='Two input'>
                            <Form.Item
                              label="Agent Name"
                              name="agentName"
                              rules={[{ required: true, message: 'Please Enter Your Name!' }]}
                              className="input-container"
                            >
                              <Input onChange={(e) => setAgentName(e.target.value)} />
                            </Form.Item>
                            <Form.Item
                              label="Agent Mobile Number"
                              name="agentNum"
                              rules={[{ required: true, message: 'Please Enter Mobile Number!' }, { pattern: /^[0-9]{10}$/, message: 'Please Enter Valid Mobile Number!' }]}
                              className="input-container"
                            >
                              <Input onChange={(e) => setAgentNum(e.target.value)} />
                            </Form.Item>
                          </div>
                        </Form>
                        <h2>Anchor Details :</h2>
                      </div>
                    }
                    <Form
                      form={form}
                      layout="vertical"
                      size="large"
                      className="form-container"
                    >
                      <div className='Two input'>
                        <Form.Item
                          label="Anchor Name"
                          name="fullName"
                          rules={[{ required: true, message: 'Please Enter Your Name!' }]}
                          className="input-container"
                        >
                          <Input onChange={(e) => setFullName(e.target.value)} />
                        </Form.Item>
                        <Form.Item
                          label="Mobile Number"
                          name="mobile"
                          rules={[{ required: true, message: 'Please Enter Mobile Number!' }, { pattern: /^[0-9]{10}$/, message: 'Please Enter Valid Mobile Number!' }]}
                          className="input-container"
                        >
                          <Input onChange={(e) => setMobile(e.target.value)} />
                        </Form.Item>
                      </div>

                      <div className='Two input'>
                        <Form.Item
                          label="Email Address"
                          name="emailId"
                          rules={[{ required: true, message: 'Please Enter Your Email address!' }]}
                          className="input-container"
                        >
                          <Input onChange={(e) => setEmailId(e.target.value)} />
                        </Form.Item>
                        <Form.Item
                          label="Known Languages (English,Tamil...etc)"
                          name="language"
                          rules={[{ required: true, message: 'Please Enter Your known Languages!' }]}
                          className="input-container"
                        >
                          <Input onChange={(e) => setLanguage(e.target.value)} />
                        </Form.Item>
                      </div>
                      <div className='Two input'>
                        <Form.Item
                          label="Gender"
                          name="category"
                          rules={[{ required: true, message: 'Please Select a Category!' }]}
                          className="input-container"
                        >
                          <Select onChange={(value) => setCategory(value)}>
                            <Select.Option value="Male">Male</Select.Option>
                            <Select.Option value="Female">Female</Select.Option>
                            <Select.Option value="ChildArtist">Child Artist</Select.Option>
                          </Select>
                        </Form.Item>

                        <Form.Item
                          label="Age"
                          name="age"
                          rules={[{ required: true, message: 'Please Enter Your Age!' }]}
                          className="input-container"
                        >
                          <Input type="number" onChange={(e) => setAge(e.target.value)} />
                        </Form.Item>
                      </div>
                      <div className='Two input'>
                        <Form.Item
                          label="Describe Yourself (Max 200 words!)"
                          name="description"
                          rules={[
                            { required: true, message: 'Please describe about yourself!' },
                            { validator: validateWordCount }
                          ]}
                          className="input-container"
                        >
                          <TextArea 
                            rows={6} 
                            onChange={(e) => setDescription(e.target.value)}
                          />
                        </Form.Item>
                        <div className="input-container">
                          <Form.Item
                            label="Specialization"
                            name="specialization"
                            rules={[{ required: true, message: 'Please select at least one specialization!' }]}
                          >
                            <Select
                              mode="multiple"
                              placeholder="Select specializations"
                              onChange={handleSpecializationChange}
                              allowClear
                            >
                              <Select.Option value="Corporate Events">Corporate Events</Select.Option>
                              <Select.Option value="Weddings">Weddings</Select.Option>
                              <Select.Option value="Award Shows">Award Shows</Select.Option>
                              <Select.Option value="Conferences">Conferences</Select.Option>
                              <Select.Option value="Seminars">Seminars</Select.Option>
                              <Select.Option value="Product Launches">Product Launches</Select.Option>
                              <Select.Option value="TV Shows">TV Shows</Select.Option>
                              <Select.Option value="Radio">Radio</Select.Option>
                              <Select.Option value="Live Events">Live Events</Select.Option>
                              <Select.Option value="Sports Events">Sports Events</Select.Option>
                              <Select.Option value="Cultural Events">Cultural Events</Select.Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            label="Years of Experience"
                            name="yearofexperience"
                            rules={[{ required: true, message: 'Please enter your experience!' }]}
                          >
                            <Input 
                              type="number" 
                              onChange={(e) => setYearofexperience(e.target.value)}
                            />
                          </Form.Item>
                        </div>
                      </div>

                      <div className="Two input">
                        <Form.Item
                          label="Paste Your Instagram link"
                          name="instaLink"
                          rules={[{ required: true, message: 'Please Paste Your Instagram URL!' }]}
                          className="input-container"
                        >
                          <Input onChange={(e) => setInstaLink(e.target.value)} />
                        </Form.Item>

                        <Form.Item
                          label="Referral Code"
                          name="refcode"
                          className="input-container"
                        >
                          <Input onChange={(e) => setRefCode(e.target.value)} />
                        </Form.Item>

                        <Form.Item
                          label="Coupon Code"
                          help={message}
                          validateStatus={discount > 0 ? 'success' : message && 'error'}
                        >
                          <Space.Compact style={{ width: '100%' }}>
                            <Input
                              value={coupon}
                              onChange={(e) => setCoupon(e.target.value)}
                              placeholder="Enter coupon code"
                              disabled={discount > 0}
                            />
                            <Button
                              type="primary"
                              onClick={applyCoupon}
                              loading={loading}
                              disabled={discount > 0}
                            >
                              {discount > 0 ? 'Applied' : 'Apply'}
                            </Button>
                          </Space.Compact>
                        </Form.Item>
                      </div>
                      <Form.Item>
                        <Button type="primary" htmlType="submit" onClick={handleSubmit}>
                          Next
                        </Button>
                      </Form.Item>
                    </Form>
                  </>
                )}
                {currentStep === 1 && (
                  <Form>
                    <div >
                      <div className="upload-container">
                        <div style={{ marginBottom: '40px', textAlign: 'center', lineHeight: '5px' }}>
                          <h3>Upload Poster </h3>
                          <h4 style={{ marginBottom: '15px'}}>( 500 x 750 px)</h4>
                          <Form.Item
                            style={{justifyItems:'center'}}
                            name="poster"
                            rules={[{ required: true, message: 'Please Upload the Poster' }]}
                            className="input-container"
                          >
                            <Upload
                              listType="picture-card"
                              onPreview={handlePreview}
                              beforeUpload={(file) => {
                                const MAX_FILE_SIZE = 5 * 1024 * 1024;
                                if (file.size > MAX_FILE_SIZE) {
                                  notification.error({
                                    message: 'File Too Large',
                                    description: 'File size exceeds the maximum limit of 5MB.',
                                    placement: 'top'
                                  });
                                  return Upload.LIST_IGNORE;
                                }
                                return true;
                              }}
                              onChange={handleImageUpload}
                              maxCount={1}
                              accept="image/*"
                            >
                              {uploadButton}
                            </Upload>
                          </Form.Item>
                          <span>( Maximum 5MB )</span>
                          <Modal open={previewOpen} title={previewTitle} footer={null}
                            onCancel={handleCancel}
                          >
                            <img
                              alt="example"
                              style={{
                                width: '100%',
                              }}
                              src={previewImage}
                            />
                          </Modal >
                        </div>
                        <div style={{ marginBottom: '40px', textAlign: 'center', lineHeight: '5px' }}>
                          <h3>Upload Thumbnail</h3>
                          <h4 style={{ marginBottom: '15px'}}>( 1280 x 720 px )</h4>
                          <Form.Item
                            style={{justifyItems:'center'}}
                            name="thumbnail"
                            rules={[{ required: true, message: 'Please Upload the Thumbnail' }]}
                            className="input-container"
                          >
                            <Upload
                              listType="picture-card"
                              onPreview={handlePreview}
                              beforeUpload={(file) => {
                                const MAX_FILE_SIZE = 5 * 1024 * 1024;
                                if (file.size > MAX_FILE_SIZE) {
                                  notification.error({
                                    message: 'File Too Large',
                                    description: 'File size exceeds the maximum limit of 5MB.',
                                    placement: 'top'
                                  });
                                  return Upload.LIST_IGNORE;
                                }
                                return true;
                              }}
                              onChange={handleImageUpload1}
                              maxCount={1}
                              accept="image/*"
                            >
                              {uploadButton}
                            </Upload>
                          </Form.Item>
                          <span>( Maximum 5MB )</span>
                          <Modal open={previewOpen} title={previewTitle} footer={null}
                            onCancel={handleCancel}
                          >
                            <img
                              alt="example"
                              style={{
                                width: '100%',
                              }}
                              src={previewImage}
                            />
                          </Modal>
                        </div>
                        <div style={{ marginBottom: '40px', textAlign: 'center', lineHeight: '5px' }}>
                          <h3>Upload Images</h3>
                          <h4 style={{ marginBottom: '15px'}}>( Max 5 images )</h4>
                          <Form.Item
                            style={{justifyItems:'center'}}
                            name="images"
                            rules={[{ required: true, message: 'Please Upload the Images' }]}
                            className="input-container"
                          >
                            <Upload
                              listType="picture-card"
                              onPreview={handlePreview}
                              onChange={handleImageUpload2}
                              beforeUpload={(file) => {
                                const MAX_FILE_SIZE = 5 * 1024 * 1024;
                                if (file.size > MAX_FILE_SIZE) {
                                  notification.error({
                                    message: 'File Too Large',
                                    description: 'File size exceeds the maximum limit of 5MB.',
                                    placement: 'top'
                                  });
                                  return Upload.LIST_IGNORE;
                                }
                                return true;
                              }}
                              multiple
                              maxCount={5}
                              accept="image/*"
                            >
                              {imagesUpload.length < 5 && uploadButton}
                            </Upload>
                          </Form.Item>
                          <span>( Max 5MB Each )</span>
                        </div>

                        <div style={{ marginBottom: '40px', textAlign: 'center', lineHeight: '5px' }}>
                          <h3>Upload Reel</h3>
                          <h4 style={{ marginBottom: '15px'}}>(1080 x 1920 px)</h4>
                          <Form.Item
                            style={{justifyItems:'center'}}
                            name="reel"
                            rules={[{ required: false, message: 'Please upload the reel' }]}
                            className="input-container"
                          >
                            <Upload
                              listType="picture-card"
                              onPreview={handlePreview}
                              beforeUpload={(file) => {
                                const MAX_FILE_SIZE = 200 * 1024 * 1024;
                                if (file.size > MAX_FILE_SIZE) {
                                  notification.error({
                                    message: 'File Too Large',
                                    description: 'Reel size exceeds the limit of 200MB.',
                                    placement: 'top'
                                  });
                                  return Upload.LIST_IGNORE;
                                }
                                const isMp4 = file.type === 'video/mp4';
                                if (!isMp4) {
                                  notification.error({
                                    message: 'Invalid Format',
                                    description: 'Only MP4 format is allowed for reels.',
                                    placement: 'top'
                                  });
                                  return Upload.LIST_IGNORE;
                                }
                                return true;
                              }}
                              onChange={handleVideoUpload}
                              maxCount={1}
                              accept="video/mp4"
                            >
                              {uploadButton}
                            </Upload>
                          </Form.Item>
                          <span>( Maximum 200MB, MP4 only )</span>
                        </div>
                      </div>
                      <Progress percent={calculateOverallProgress()} />
                      <div style={{ marginTop: 40 }}>
                        <Button onClick={prevStep}>
                          <LeftOutlined /> Previous
                        </Button>
                        <Button 
                          type="primary" 
                          disabled={buttonDisabled} 
                          style={{ float: 'right' }} 
                          onClick={handleUpload}
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
                
                {currentStep === 2 && (
                  <div>
                    <div style={{ height: '500px', overflow: 'auto' }}>
                      <h2>Terms and Conditions for Agent Anchor Application</h2>
                      <ol>
                        <li><strong style={{ color: '#ff0015' }}>Categories</strong>: The contest is open to three categories of anchors: male, female, and child artist.</li>
                        <li><strong style={{ color: '#ff0015' }}>Eligibility</strong>: Applicants must meet the age and other eligibility requirements specified for their respective category.</li>
                        <li><strong style={{ color: '#ff0015' }}>Application Process</strong>: Applicants must complete the application form accurately and submit any required supporting materials along with the payment.</li>
                        <li><strong style={{ color: '#ff0015' }}>Payment and Refunds</strong>: There is a non-refundable fee for submitting the application. No refunds will be issued after the payment is made.</li>
                        <li><strong style={{ color: '#ff0015' }}>Profile Review</strong>: After payment, each application will be reviewed. Profiles will be published on the website if they meet the contest standards and criteria.</li>
                        <li><strong style={{ color: '#ff0015' }}>Publication</strong>: Approved profiles will be published on the contest website, where they can be viewed by directors and other industry professionals.</li>
                        <li><strong style={{ color: '#ff0015' }}>Selection Criteria</strong>: Selection and approval of profiles will be based on criteria set by the contest organizers, including but not limited to communication skills, presence, and suitability for anchoring.</li>
                        <li><strong style={{ color: '#ff0015' }}>Usage Rights</strong>: By applying, applicants grant the organizers the right to use their submitted photos and personal information for promotional and contest-related purposes.</li>
                        <li><strong style={{ color: '#ff0015' }}>No Guarantee</strong>: Submission of an application and payment does not guarantee selection as a contest participant or publication of the profile.</li>
                        <li><strong style={{ color: '#ff0015' }}>Facilitation of Connections</strong>: The organizers will facilitate connections between anchors and interested parties such as event managers or others who wish to hire anchors from the published list.</li>
                        <li><strong style={{ color: '#ff0015' }}>Anchor Release</strong>: Selected participants will be required to sign an anchor form, granting the organizers permission to use their likeness in promotional materials.</li>
                        <li><strong style={{ color: '#ff0015' }}>Indemnification</strong>: Applicants agree to indemnify the contest organizers against any legal claims arising from the use of their submitted materials.</li>
                        <li><strong style={{ color: '#ff0015' }}>Termination</strong>: The organizers reserve the right to terminate the contest or disqualify participants at their discretion.</li>
                        <li><strong style={{ color: '#ff0015' }}>Compliance with Laws</strong>: Applicants must comply with all local, state, and federal laws and regulations. Failure to comply may result in disqualification.</li>
                        <li><strong style={{ color: '#ff0015' }}>Confidentiality</strong>: Applicants agree to keep all contest-related information confidential and not disclose any details to third parties without the organizer's consent.</li>
                        <li><strong style={{ color: '#ff0015' }}>Data Protection</strong>: The organizers will handle all personal data in accordance with applicable data protection laws. Applicants have the right to access and request the correction or deletion of their personal data.</li>
                      </ol>
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <Checkbox checked={agreed} onChange={toggleAgreement}>
                        I agree to the terms and conditions
                      </Checkbox>
                    </div>
                    <div style={{ marginTop: 20 }}>
                      <Button onClick={prevStep}>
                        <LeftOutlined /> Previous
                      </Button>
<Button 
  type="primary" 
  style={{ float: 'right' }} 
  onClick={handlePayment} 
  disabled={!agreed}
  loading={loading}
>
  {loading ? 'Processing...' : `Pay ₹${finalPrice}`}
</Button>
                    </div>
                  </div>
                )}
              </div>
            </ConfigProvider>
          </div>
        )}
      </div>
    </>
  )
}

export default AgentAnchorForm;